import { MESSAGES } from "@app/constant";
import { throwImageFiltering } from "@app/helpers/uploadFileValidation";

import { handleDeleteImageProps, onChangeUploadProps } from "./types";

export const onChangeUpload = ({
  event,
  isPdf,
  images,
  setValue,
  setState,
  setError,
}: onChangeUploadProps) => {
  setState((prev) => ({ ...prev, largeImageMessage: '' }))

  const key = isPdf ? 'pdf' : 'images'

  try {
    const fileList = event.target?.files as FileList;
    const onChangeFiles = throwImageFiltering(fileList, isPdf || false)
    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    if (!onChangeFiles) {
      setError(key, { message: MESSAGES.imageIsRequired })
    }

    if (((images?.length || 0) + chosenImagesLength) > 5) {
      setError(key, { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList.length !== onChangeFiles.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    setValue(key, onChangeFiles)
  } catch (error) {
    console.log('Error:', error);
  }
}

export const handleDeleteImage = ({
  base64,
  previews,
  setValue,
  setState,
  images,
}: handleDeleteImageProps) => {
  const index = previews.findIndex((item) => item === base64);

  const files = Array.from(images).filter((_, i) => i !== index);

  const mergedFileList = new DataTransfer();

  files.forEach((file) => {
    mergedFileList.items.add(file);
  });

  setValue('images', mergedFileList.files)
  setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
}
